<script>
import { get } from 'svelte/store';
import { _, locale, locales } from 'svelte-intl';

// locales
const currentLocales = get(locales);
let currentLocale = get(locale);

function changeLocale(newLocale) {
  locale.set(newLocale);
  currentLocale = newLocale;
  try {
    localStorage.setItem('lang', newLocale);
  } catch(e) {
    console.error('Error when trying to set new value to localStorage');
  }
}
</script>


<div class="lang-switch">
  {#each currentLocales as loc}
    <span on:click={() => changeLocale(loc)} class:selected={loc === currentLocale}>{$_(`lang.${loc}`)}</span>
  {/each}
</div>


<style>
.lang-switch {
  position: absolute;
  z-index: 3;
  right: 6rem;
  top: 5rem;
  animation: animLangSwitcher 0.8s cubic-bezier(.36,.62,.53,1.13) forwards;
}

.lang-switch span {
  position: relative;
  margin-right: 3rem;
  color: #ffffff;
  text-decoration: none;
  font-size: 1.8rem;
  font-weight: 400;
  opacity: 0.7;
  transition: 0.2s;
  cursor: pointer;
}

.lang-switch span:last-child {
  margin-right: 0;
}

.lang-switch span:last-child:after {
  content: none;
}

.lang-switch span:hover {
  opacity: 1;
}

.lang-switch span.selected {
  font-weight: 700;
  opacity: 1;
}

@keyframes animLangSwitcher {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}


@media(max-width: 767px) {
  .lang-switch {
    top: 3rem; 
    right: 3rem;
  }
}
</style>